import { call, put } from "redux-saga/effects";

import { getInterestPoints as getInterestPointsRequest } from "../services/points-of-interest";
import { Creators as interestActions } from "../actions/interestPoints";

export default function* getInterestPoints() {
  try {
    const list = yield call(getInterestPointsRequest);
    yield put(interestActions.getInterestPointsSuccess(list));
  } catch (error) {
    yield put(interestActions.getInterestPointsFailure(error));
  }
}
